import React from "react";
import Box from "@carrier-io/air-react/Box";
import Typography from "@carrier-io/air-react/Typography";
import { colors } from "../../styles/colors";

interface AdminHead {
  title: string;
  description?: string;
}

export const AdminHead: React.FC<AdminHead> = ({ title, description }) => {
  return (
    <Box
      sx={{
        padding: "16px 32px 40px",
        borderBottom: `1px solid ${colors.borderColorLight}`,
      }}
    >
      <Typography
        variant="h4"
        data-testid="page-title"
        sx={{
          paddingTop: "28px",
          marginBottom: "4px",
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography
          paragraph
          sx={{
            marginBottom: "0",
          }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};
